import React from 'react'
import { SelectVehicleTypeContext } from './SelectVehicleTypeContext'

export const useShowVehicleTypeSelector = () => {
  const context = React.useContext(SelectVehicleTypeContext)
  if (context === undefined || !context.hasBeenProvided) {
    console.error('useShowVehicleTypeSelector must be used within a SelectVehicleTypeContext')
  }

  return context
}
